<div class="wrapper">
    <div class="title">{{"title.contactPerson" | translate}}</div>
    <img [src]="'assets/img/profile/' + vad.image" [alt]="vad.name" />
    <div class="name">{{vad.name}}</div>
    <a class="mail" [href]="'mailto:' + vad.mail" target="_blank">{{vad.mail}}</a>
    <a class="phone" [href]="'tel:' + vad.phone" target="_blank">{{vad.phone}}</a>
</div>